export type VendorAuthMode = "cookie" | "legacy";

/** Production default is cookie (httpOnly session). Set VITE_VENDOR_AUTH_MODE=legacy only for local dev rollback. */
export function getVendorAuthMode(): VendorAuthMode {
  const raw = import.meta.env.VITE_VENDOR_AUTH_MODE?.trim().toLowerCase();
  if (raw === "legacy") return "legacy";
  return "cookie";
}

export function isCookieVendorAuthMode(): boolean {
  return getVendorAuthMode() === "cookie";
}

/** Same-origin vendor API base (Nitro proxy routes). */
export const VENDOR_API_BASE = "/api/vendor";

export function vendorApiUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${VENDOR_API_BASE}${normalized}`;
}
